<template>
    <v-container class="h-100 dictionary-page">
      <v-card class="card-container">
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <v-btn
                      dense
                      color="var(--color-blue)"
                      @click="showAddModal"
                      dark
              >
                <span class="btn-text"><v-icon dark>add</v-icon> Добавить штраф</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field
                      class="search-block"
                      v-model="search"
                      prepend-inner-icon="mdi-magnify"
                      single-line
                      solo
                      placeholder="Поиск"
                      dense
                      hide-details
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
          <v-data-table
                  no-data-text="Нет элементов"
                  no-results-text="Не найдено элементов"
                  loading-text="Загрузка данных"
                  calculate-widths
                  :items-per-page="filteredItems.length"
                  :items="filteredItems"
                  :headers="fields"
                  :search="search"
                  height="100%"
                  hide-default-footer
                  class="elevation-1 h-100"
          >

            <template v-slot:item.edit="{item}">
              <v-btn icon @click="showEditModal(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <b-modal
              id="modalAddFine"
              centered
              size="lg"
              title="Добавление штрафа"
      >
        <b-container fluid>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Статья</label>
              <b-input
                      v-model="editModel.fineArticle"
                      required
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Описание</label>
              <b-textarea
                      v-model="editModel.shortDescription"
                      required
                      rows="4"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Санкция</label>
              <b-input
                      v-model="editModel.fineSanction"
                      required
              />
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col>
              <label class="custom-input-label">Совет</label>
              <b-textarea
                      v-model="editModel.fineAdvice"
                      rows="3"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Комментарий</label>
              <b-textarea
                      v-model="editModel.fineComment"
                      rows="3"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Разграничения</label>
              <b-textarea
                      v-model="editModel.fineDemarcation"
                      rows="3"
              />
            </b-col>
          </b-row>
        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">

              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalAddFine')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </template>
      </b-modal>

      <b-modal
              id="modalEditFine"
              size="lg"
              centered
              title="Редактирование штрафа"
      >
        <b-container fluid>
          <b-row class="mb-1">
            <b-col>
              <label class="custom-input-label">Статья</label>
              <b-input
                      v-model="editModel.fineArticle"
                      required
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Описание</label>
              <b-textarea
                      v-model="editModel.shortDescription"
                      required
                      rows="4"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Санкция</label>
              <b-input
                      v-model="editModel.fineSanction"
                      required
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Совет</label>
              <b-textarea
                      v-model="editModel.fineAdvice"
                      rows="3"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Комментарий</label>
              <b-textarea
                      v-model="editModel.fineComment"
                      rows="3"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Разграничения</label>
              <b-textarea
                      v-model="editModel.fineDemarcation"
                      rows="3"
              />
            </b-col>
          </b-row>
        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">
              <v-col cols="auto">
                <v-btn
                        outlined
                        color="var(--color-red)"
                        size="sm"
                        @click="deleteItem"
                >
                  <v-icon>mdi-delete</v-icon> Удалить
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalEditFine')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </template>
      </b-modal>
    </v-container>
</template>

<script>
  import mapper from 'automapper'
    export default {
      name: "Fines",
      data() {
          return {
              perPage: 15,
              curPage: 1,
              editModel: {
                  id: null,
                  fineArticle: null,
                  shortDescription: null,
                  fineAdvice: null,
                  fineSanction: null,
                  fineComment: null,
                  fineDemarcation: null
              },
              search: "",
              fields: [
                  {text: 'Статья', value: 'fineArticle', sortable: true, width: 90},
                  {text: 'Описание', value: 'shortDescription'},
                  {value: "edit", text: "", width: 50},
              ],
              selected: null,
          }
      },

      computed: {
        filteredItems() {
          var items = this.$store.state.Fines.items;
          if(items!=null) {
            return items.filter((elem) => {
              return new RegExp(this.search, 'ig').test(elem.fineArticle)||new RegExp(this.search, 'ig').test(elem.shortDescription);
            });
          }
          else return [];
        },

        totalRows(){
          return this.filteredItems.length;
        }
      },
      created: function () {
        //заполняем данные справочника
        this.$store.dispatch("Fines/loadFines").catch((err) => {
          this.$bvToast.toast(err.message, {
            title: `Ошибка загрузки штрафов!`,
            variant: "danger",
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 3000,
            solid: true
          })

        });
        mapper.createMap("fineModel", "fineEditModel")
      },

      methods: {
        showEditModal(item) {
            this.selected=item
          mapper.map("fineModel", "fineEditModel", this.selected, this.editModel)
          this.$bvModal.show('modalEditFine')
        },
        showAddModal() {
          this.resetModel();
          this.$bvModal.show('modalAddFine')
        },

        resetModel(){
          for(var key in this.editModel){
            this.editModel[key]=null;
          }
        },

        rowSelected(row) {
          this.selected = row[0]
        },

        onSave(){
          //если есть id, то редактируем запись, иначе добавляем
          if(this.editModel.id!=null){
            try {
              this.$store.dispatch('Fines/editFine', this.editModel).then(()=> {
                  this.$bvToast.toast("Штраф успешно обновлен", {
                    variant: "success",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                }
              ).catch(err=>{
                this.$bvToast.toast(err.message, {
                  title: `Ошибка!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              });
            }catch(e){
              console.log(e)
            }
            this.$bvModal.hide('modalEditFine')
          }
          else{
            try {
              this.$store.dispatch('Fines/addFine', this.editModel).then(()=>{
                this.$bvToast.toast("Штраф успешно добавлен",{
                  variant: "success",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              }).catch(err=>{
                this.$bvToast.toast(err.message, {
                  title: `Ошибка!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              });
            }catch(e){
              console.log(e)
            }
            this.$bvModal.hide('modalAddFine')
          }
        },

        deleteItem() {
          const vm=this;
          this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
            title: 'Подтверждение',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Удалить',
            cancelTitle: 'Отмена',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
            .then(value => {
              if(value==true){
                this.$store.dispatch("Fines/deleteFine", vm.selected.id).then(()=>{
                  vm.$bvToast.toast("Штраф успешно удален",{
                    variant: "success",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                }).catch(err=>{
                  vm.$bvToast.toast(err.message, {
                    title: `Ошибка!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                });
                this.selected=null;
              }
            })
            .catch(err => {
              // An error occurred
            })
        }
      }

    }
</script>

<style scoped>

</style>
